/**
 * 用于解决一些浏览器兼容性问题
 */
;(function() {
  // 这里解决nodelist在部分浏览器无法使用forEach的问题
  if (
    typeof NodeList !== 'undefined' &&
    NodeList.prototype &&
    !NodeList.prototype.forEach
  ) {
    NodeList.prototype.forEach = Array.prototype.forEach
  }
})()
